import React from 'react'
import styled from 'styled-components'

const PADDING = 17;
const ICON_WIDTH = 28;

export const StyledComponent = styled(
  ({...rest}) => <div {...rest} />
)`
border-radius: 4px;

background: rgba(255, 255, 255, 1);


font-weight: 400;
font-size: 12px;
line-height: 15.53px;
letter-spacing: 0px;

p {
  font-size: 12px;
  margin: 0;
}

color: rgba(91, 107, 127, 1);
font-family: ${p => p.theme.fontFamilyBase};

a {
  color: ${props => props.theme.cLinkLightBlue};
  text-decoration: none;
}

a:hover {
  color: ${props => props.theme.cLinkLightBlue};
}


& header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 10px ${PADDING}px;

  background: rgba(27, 83, 102, 1);
  color: rgba(255, 255, 255, 1);

  border-radius: 4px;
}

& header h2 {
  font-size: 14px;
  line-height: 21.79px;
  margin: 0;
}

& .contact-us-content-body {
  padding: 15px ${PADDING}px;

  border-radius: 0 0 4px 4px;
}

& section {
  padding-left: ${ICON_WIDTH}px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  &.support-time-section {
    padding-left: 0;
    margin-bottom: 15px;

    p {
      margin-bottom: 5px;
    }

    .support-title {
      font-size: 14px;
    }
  }

  .with-icon-wrapper {
    margin-left: -${ICON_WIDTH}px;
    margin-bottom: 8px;

    display: flex;
    align-items: flex-start;

    .icon-wrapper {
      width: ${ICON_WIDTH}px;
    }

    .label-wrapper {
      font-size: 14px;
      p {
        font-size: 14px;
        margin: 0;
      }
    }
  }

  &.socials-section {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 0;

    p {
      font-size: 14px;
      margin: 0;
    }

    .socials-links {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    a {
      display: flex;
      align-items: center;
      width: 28px;
      height: 28px;
    }
  }
}

${p => p.css}
`
const _ContactUs_ContentWrapper = (props) => <StyledComponent {...props} />
_ContactUs_ContentWrapper.propTypes = {}
_ContactUs_ContentWrapper.className = StyledComponent

export default _ContactUs_ContentWrapper
